/* eslint-disable @typescript-eslint/no-explicit-any -- TODO: Clean code !!! */
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./grid.component.html?ngResource";
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import _ from 'lodash';
import { NgxSmartModalService, NgxSmartModalModule } from 'ngx-smart-modal';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { ContextMenuModule } from 'primeng/contextmenu';
import { PrimeNGConfig, FilterMatchMode } from 'primeng/api';
import { ObjectUtils } from 'primeng/utils';
import filterModeOverride from './filterMatchModes.overrides';
import { FileUploadModule } from 'primeng/fileupload';
import { FormioUtils } from '@formio/angular';
import { Form } from 'formiojs';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicFormatPipe } from 'src/ng-app/pipes/dynamicFormat.pipe';
import { DynamicFormsComponent } from '../dynamic-forms/dynamic-forms.component';
let GridComponent = class GridComponent {
    ngxSmartModalService;
    config;
    source;
    columns;
    resourceSchema;
    options;
    count;
    selected;
    sortMeta = [];
    clearTable;
    rowChanged = new EventEmitter();
    rowDeleted = new EventEmitter();
    rowAdded = new EventEmitter();
    lazyLoad = new EventEmitter();
    exportClicked = new EventEmitter();
    importSuccess = new EventEmitter();
    resourceTableVC;
    fugrid;
    menu;
    selectedColumns = [];
    first = 0;
    uploading = false;
    formChanges;
    formModel;
    gridApi;
    loading = false;
    selectedItem;
    isFormValid = false;
    uploadError;
    contextItems;
    selectedRowItem;
    uploadValidationsError;
    columnSortOrder = new Map();
    constructor(ngxSmartModalService, config) {
        this.ngxSmartModalService = ngxSmartModalService;
        this.config = config;
    }
    ngOnInit() {
        this.contextItems = [
            { label: 'Edit', icon: 'fad fa-fw fa-pencil', command: () => this.openEditModal(this.selectedRowItem) },
            { label: 'Delete', icon: 'fad fa-fw fa-times', command: () => this.onActionDeleteClick(this.selectedRowItem) }
        ];
        _.pull(this.config.filterMatchModeOptions.text, FilterMatchMode.NOT_CONTAINS);
        this.selectedColumns = this.columns || [];
        if (this.clearTable) {
            this.clearTable.subscribe(() => {
                if (this.resourceTableVC) {
                    this.resourceTableVC.clear();
                }
            });
        }
    }
    resolveFieldData = (data, field) => ObjectUtils.resolveFieldData(data, field);
    rowTracker = (_index, item) => item.id;
    openEditModal(data) {
        this.formModel = _.cloneDeep(data);
        this.ngxSmartModalService.setModalData({
            model: this.formModel,
            schema: this.resourceSchema
        }, 'editResourceModal');
        this.ngxSmartModalService.open('editResourceModal');
    }
    onFormFeedback($event) {
        this.isFormValid = $event.data;
    }
    onFormChange($event) {
        if ($event.model) {
            this.formChanges = $event.model;
        }
    }
    closeEditModal() {
        this.rowChanged.emit(this.formChanges);
        this.ngxSmartModalService.close('editResourceModal');
    }
    onActionDeleteClick($event) {
        this.rowDeleted.emit($event);
    }
    rowSelected($event) {
        this.selectedRowItem = this.selectedItem;
        $event.originalEvent?.stopPropagation();
        if (this.options?.contextMenu) {
            this.menu?.show($event.originalEvent);
        }
    }
    onError($event) {
        this.uploadError = $event.error;
        this.uploading = false;
        this.resetImportUpload();
    }
    onBeforeUpload($event) {
        const { formData } = $event;
        const { model, schema } = this.ngxSmartModalService.getModalData('importResourceModal');
        if (model && schema) {
            const flattened = FormioUtils.flattenComponents(schema.components, false);
            // TODO: handle nested/multi-layer model objects
            _.forOwn(model, (value, key) => {
                key = _.get(flattened, [key, 'properties', 'importMultipleKeyOverride'], key);
                formData.set(key, value);
            });
        }
    }
    onImportFileSelect() {
        this.uploadError = null;
    }
    onUpload() {
        this.uploading = true;
        this.fugrid.upload();
    }
    onUploadSuccess($event) {
        this.uploading = false;
        const { originalEvent, files } = $event;
        const errors = originalEvent?.body?.errors;
        if (errors?.length) {
            this.uploadValidationsError = errors.join('\n');
        }
        else {
            this.ngxSmartModalService.close('importResourceModal');
        }
        this.importSuccess.emit(files[0].name);
    }
    addResource() {
        this.ngxSmartModalService.setModalData({
            model: {},
            schema: this.resourceSchema
        }, 'addResourceModal');
        this.ngxSmartModalService.open('addResourceModal');
    }
    async openUploadModal() {
        const pluckedSchema = _.cloneDeep(this.resourceSchema);
        if (pluckedSchema.components?.length === 1 && pluckedSchema.components[0].key === 'data') {
            pluckedSchema.components = pluckedSchema.components[0].components;
        }
        const fullSchemaForm = await new Form(pluckedSchema).ready;
        const componentsToRemove = new Map();
        const componentsToKeep = new Set();
        FormioUtils.eachComponent(fullSchemaForm.getComponents(), (component, path) => {
            if (_.get(component, ['component', 'properties', 'displayOnImportMultiple']) === 'true') {
                _.reduce(path.split('.'), (acc, part) => {
                    acc = `${acc}${acc ? '.' : ''}${part}`;
                    componentsToKeep.add(acc);
                    return acc;
                }, '');
            }
            else {
                componentsToRemove.set(path, component);
            }
        }, true);
        componentsToRemove.forEach((component, path) => {
            if (!componentsToKeep.has(path)) {
                const { parent } = component;
                parent.removeComponent(component);
            }
        });
        let { schema } = fullSchemaForm;
        if (!schema.components?.length) {
            schema = null;
            this.isFormValid = true; // set as valid so 'import' button is enabled
        }
        this.ngxSmartModalService.setModalData({
            model: {},
            schema
        }, 'importResourceModal');
        this.ngxSmartModalService.open('importResourceModal');
    }
    onImportClose() {
        this.uploadError = null;
        this.uploadValidationsError = null;
        this.resetImportUpload();
        this.ngxSmartModalService.resetModalData('importResourceModal');
    }
    resetImportUpload() {
        this.fugrid.clear();
        this.fugrid.uploadedFileCount = 0; // manually reset here since the modal isn't truely destroyed
    }
    closeAddModal() {
        this.rowAdded.emit(this.formChanges);
        this.ngxSmartModalService.close('addResourceModal');
    }
    /**
     * Called whenever a modal is closed to clear the model
     * This is needed because within the ngx-modal the form component is only initialized once ever
     *
     * @memberof GridComponent
     */
    resetFormModel() {
        this.ngxSmartModalService.resetModalData('addResourceModal');
        this.ngxSmartModalService.resetModalData('editResourceModal');
    }
    loadDataLazy(event) {
        this.loading = true;
        _.forOwn(event?.filters, (filters) => {
            _.forEach(filters, filter => filter.matchMode = filterModeOverride[filter.matchMode] || filter.matchMode);
        });
        this.lazyLoad.emit(event);
        this.loading = false;
    }
    handleExport($event) {
        this.exportClicked.emit($event);
    }
    ngOnChanges(changes) {
        if (changes.columns) {
            this.mapColumnSortOrder();
            this.selectedColumns = this.columns;
        }
        if (changes.selected) {
            this.selectedItem = changes.selected.currentValue;
        }
    }
    mapColumnSortOrder() {
        this.columnSortOrder.clear();
        (this.columns || []).forEach((column, index) => {
            this.columnSortOrder.set(column, index);
        });
    }
    reorderSelectedColumns() {
        this.selectedColumns.sort((a, b) => {
            const aIndex = this.columnSortOrder.get(a);
            const bIndex = this.columnSortOrder.get(b);
            return aIndex - bIndex;
        });
        this.selectedColumns = [...this.selectedColumns]; // trigger change detection
    }
    onColumnSelectionChange() {
        this.reorderSelectedColumns();
    }
    isSelectedItem(item) {
        return this.selectedItem && this.selectedItem === item;
    }
    static ctorParameters = () => [
        { type: NgxSmartModalService },
        { type: PrimeNGConfig }
    ];
    static propDecorators = {
        source: [{ type: Input }],
        columns: [{ type: Input }],
        resourceSchema: [{ type: Input }],
        options: [{ type: Input }],
        count: [{ type: Input }],
        selected: [{ type: Input }],
        sortMeta: [{ type: Input }],
        clearTable: [{ type: Input }],
        rowChanged: [{ type: Output }],
        rowDeleted: [{ type: Output }],
        rowAdded: [{ type: Output }],
        lazyLoad: [{ type: Output }],
        exportClicked: [{ type: Output }],
        importSuccess: [{ type: Output }],
        resourceTableVC: [{ type: ViewChild, args: ['resourceTable',] }],
        fugrid: [{ type: ViewChild, args: ['fugrid',] }],
        menu: [{ type: ViewChild, args: ['cm',] }]
    };
};
GridComponent = __decorate([
    Component({
        selector: 'grid',
        template: __NG_CLI_RESOURCE__0,
        standalone: true,
        imports: [
            CommonModule,
            FormsModule,
            FileUploadModule,
            MultiSelectModule,
            TableModule,
            NgxSmartModalModule,
            ContextMenuModule,
            DynamicFormatPipe,
            DynamicFormsComponent
        ],
    })
], GridComponent);
export { GridComponent };
